var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditDocIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit-File-name",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.182,
    height: 15.182,
    viewBox: "0 0 15.182 15.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M14.014,47.227a.379.379,0,0,0-.378.38v3.377A1.139,1.139,0,0,1,12.5,52.125H1.891A1.139,1.139,0,0,1,.756,50.984V41.073a1.139,1.139,0,0,1,1.134-1.141H5.248a.38.38,0,0,0,0-.761H1.891A1.9,1.9,0,0,0,0,41.073v9.911a1.9,1.9,0,0,0,1.891,1.9H12.5a1.9,1.9,0,0,0,1.891-1.9V47.607A.379.379,0,0,0,14.014,47.227Zm0,0",
    transform: "translate(0 -37.704)",
    fill: "#535765"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M118.315.758a1.7,1.7,0,0,0-2.4,0l-6.729,6.729a.377.377,0,0,0-.1.166l-.885,3.195a.377.377,0,0,0,.464.464l3.195-.885a.377.377,0,0,0,.166-.1L118.757,3.6a1.7,1.7,0,0,0,0-2.4Zm-8.308,6.974,5.507-5.507L117.29,4l-5.507,5.507Zm-.355.712,1.419,1.419-1.963.544Zm8.572-5.376-.4.4-1.776-1.776.4-.4a.943.943,0,0,1,1.333,0l.443.443A.944.944,0,0,1,118.224,3.067Zm0,0",
    transform: "translate(-104.072 -0.261)",
    fill: "#535765"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDocIcon);
export default __webpack_public_path__ + "static/media/EditDocIcon.df5e9e4e6f4e6c0c308525cd5983a824.svg";
export { ForwardRef as ReactComponent };